import { Routes, Route, Navigate } from 'react-router-dom'
import { AdminNavProvider, AdminShell } from '../admin/AdminShell.jsx'
import GShell from '../admin/gg/GShell.jsx'
import GFeaturesHub from '../admin/gg/GFeaturesHub.jsx'
import GFormats from '../admin/gg/GFormats.jsx'
import GMultiFormat from '../admin/gg/GMultiFormat.jsx'
import GGamesPlay from '../admin/gg/GGamesPlay.jsx'
import GSavedGames from '../admin/gg/GSavedGames.jsx'
import GHistory from '../admin/gg/GHistory.jsx'
import GSeasonMode from '../admin/gg/GSeasonMode.jsx'
import GMultiGroup from '../admin/gg/GMultiGroup.jsx'
import GMasterRound from '../admin/gg/GMasterRound.jsx'
import GHelp from '../admin/gg/GHelp.jsx'
import GAppSettings from '../admin/gg/GAppSettings.jsx'
import ClubData from '../admin/ClubData.jsx'
import { GAME_PAGES } from '../admin/AdminApp.jsx'
import GgcMemberGate from './GgcMemberGate.jsx'

// Standalone Golf Game Central (throwaway test site, VITE_GGC_ONLY). The EXACT
// current GGC page + game/format/handicap pages, in the full branded frame —
// AdminShell sidebar (reduced to only "Golf Game Central" via GGC_ONLY) + the
// GShell hero — REUSING the same components verbatim. NO gate, NO member login.
// Root redirects to the hub; the hub's own links (/admin/gg/...) work as-is.
export default function GgcStandalone() {
  // Public read-only FOLLOW route (/r/{code}) — no member login required, so
  // buddies with no app can watch live in the browser. The universal link also
  // deep-links into the companion app when installed.
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/r/')) {
    return (
      <div style={{ minHeight: '100vh', background: '#0E281D', padding: 16 }}>
        <Routes><Route path="/r/:code" element={<GMasterRound />} /></Routes>
      </div>
    )
  }
  return (
    <GgcMemberGate>
    <AdminNavProvider>
      <AdminShell>
        <Routes>
          <Route path="/admin/gg-features" element={<GFeaturesHub />} />
          <Route path="/admin/gg/games" element={<GShell active="gfeatures"><GGamesPlay /></GShell>} />
          <Route path="/admin/gg/saved" element={<GShell active="gfeatures"><GSavedGames /></GShell>} />
          <Route path="/admin/gg/history" element={<GShell active="gfeatures"><GHistory /></GShell>} />
          <Route path="/admin/gg/season" element={<GShell active="gfeatures"><GSeasonMode /></GShell>} />
          <Route path="/admin/gg/multigroup" element={<GShell active="gfeatures"><GMultiGroup /></GShell>} />
          <Route path="/admin/gg/help" element={<GShell active="gfeatures"><GHelp /></GShell>} />
          <Route path="/admin/gg/settings" element={<GShell active="gfeatures"><GAppSettings /></GShell>} />
          <Route path="/admin/gg/mg" element={<GShell active="gfeatures"><GMasterRound /></GShell>} />
          {GAME_PAGES.filter(({ path }) => path !== 'practice').map(({ path, C }) => (
            <Route key={path} path={`/admin/gg/games/${path}`} element={<GShell active="gfeatures"><C /></GShell>} />
          ))}
          <Route path="/admin/gg/formats" element={<GShell active="gfeatures"><GFormats /></GShell>} />
          <Route path="/admin/gg/multi-format" element={<GShell active="gfeatures"><GMultiFormat /></GShell>} />
          <Route path="/admin/club-data" element={<ClubData />} />
          <Route path="*" element={<Navigate to="/admin/gg-features" replace />} />
        </Routes>
      </AdminShell>
    </AdminNavProvider>
    </GgcMemberGate>
  )
}
